export const FRAMES_GAP = 200
export const CAPTION_GAP = 150
